import './styles.scss'
import React from 'react'
import { commonMethods } from 'Utils/commonMethods'

const UserInformation = ({ allUserData }) => {
  const categories = [
    { name: 'Regular', key: 'R' },
    { name: 'Gold', key: 'G' },
    { name: 'Platinum', key: 'P' }
  ]

  const subscriptionType = categories.find((name) => name.key === allUserData.subscription_type)

  return (
    <div>
      <div className="user-info-card">
        <div className="user-info-details">
          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-user"></i> Name
            </div>
            <div className="separation-line"></div>
            <div className="info-value">{allUserData?.first_name}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-id-badge"></i> User ID
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{allUserData?.userid}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-envelope"></i> Phone
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{allUserData?.phone}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-envelope"></i> Email
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{allUserData?.email}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-cogs"></i> Subscription Type
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{subscriptionType?.name}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-laptop"></i> App OS
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{allUserData?.appOs}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-code-branch"></i> App Version
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{allUserData?.app_version}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-calendar-alt"></i> Created At
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{commonMethods.utcToLocalTime(allUserData?.created_at)}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <i className="fas fa-calendar-check"></i> Updated At
            </div>
            <div className="separation-line"></div>

            <div className="info-value">{commonMethods.utcToLocalTime(allUserData?.updated_at)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserInformation
